import { cl, CustomElement } from '@/utils';
import ShopifyCart from '@/components/ShopifyCart';
import type  SlSelect from '@shoelace-style/shoelace/dist/components/select/select.js';

interface Variant {
  id: string
  title: string
  slug: string
  price: string
  compare_at_price: string
  stock: number
}

export default class ShopifyAdd extends CustomElement {
  static component = 'b-shopify-add';
  variants: Variant[]

  selectedVariantId: string | null = null;
  radios: HTMLInputElement[]
  select: SlSelect|null = null;
  button: HTMLButtonElement|null = null;
  priceEl: HTMLDivElement|null = null;
  compareEl: HTMLDivElement|null = null;
  shopifyCart: ShopifyCart|null = null;
  optionEls: HTMLDivElement[];
  options: {
    id: number,
    value: string
  }[]

  init() {
    this.radios = this.$$('radio');
    this.button = this.$('button');
    this.priceEl = this.$('price');
    this.compareEl = this.$('compare');
    this.select = this.$('select');
    this.optionEls = this.$$('option');
    this.shopifyCart = document.querySelector<ShopifyCart>('b-shopify-cart');

    this.options = this.optionEls.map((el) => {
      return {
        id: Number(el.getAttribute('data-option')),
        value: el.getAttribute('data-value')
      }
    });

    this.variants = this.getAttribute('variants') ? JSON.parse(this.getAttribute('variants')) : [];
    this.setAvailability(this.variants[0] ?? null);

    this.radios.forEach((radio) => {
      radio.addEventListener('change', this.selectOption);
    });

    this.select?.addEventListener('sl-change', this.selectOption);
    this.button?.addEventListener('click', this.addToCart);
  }

  selectOption = (ev: InputEvent) => {
    const target = (ev.target as HTMLInputElement);
    const targetOption = target.closest('[data-option]');
    const option = this.options.find((o) => o.id === Number(targetOption.getAttribute('data-option')));

    option.value = target.value;
    this.getVariantId();
  }

  getVariantId = () => {
    const variantSlug = this.options.map((o) => o.value).join('-');
    const variant = this.variants.find((v) => v.slug === variantSlug);
    if (variant) {
      this.selectedVariantId = variant.id;
      this.priceEl.innerHTML = variant.price;
      if (variant.compare_at_price) {
        this.compareEl.innerHTML = variant.compare_at_price;
      } else {
        this.compareEl.innerHTML = '';
      }
      this.button.removeAttribute('disabled');
    }
  }

  addToCart = () => {
    if (this.selectedVariantId && this.shopifyCart) {
      this.button.setAttribute('disabled', '');
      this.setAttribute('loading', '');

      this.shopifyCart.addToCart(this.selectedVariantId).then(() => {
        this.button.removeAttribute('disabled');
        this.removeAttribute('loading');
      });
    }
  }

  setAvailability(variant: Variant | null) {
    if (variant && variant.stock > 0) {
      this.selectedVariantId = variant.id;
      this.button.innerHTML = 'Add to Cart';
      this.button.removeAttribute('disabled');
      cl(this.button).remove('is-out-of-stock');
    } else {
      cl(this.button).add('is-out-of-stock');
      this.button.innerHTML = 'Out of Stock';
    }
  }
}
